var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('van-tag',{attrs:{"round":"","color":"#EDFFFC","text-color":"#18BEBB"}},[_vm._v(_vm._s(_vm.myValue))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }